import React, { ChangeEvent } from 'react';
import { Box, Text, Stack, Checkbox } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { SearchAndSortTypes } from '../filters/seekersFiltersContextValueType';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { FitStatus } from '../../../../firebase/firestore/documents/candidate';
import { SearchAndSortProps } from './searchAndSortType';

export const AvailabilityFit = ({ tempSearchAndSortType, setTempSearchAndSortTypes }: SearchAndSortProps): JSX.Element => {
  const { t } = useTranslation('audioEvaluation');

  const { setIsFromSearchAndSort } = useSeekersFilters();

  const onHandleBackgroundCheck = (searchAndSort: SearchAndSortTypes) => {
    setIsFromSearchAndSort(true);
    setTempSearchAndSortTypes({ ...searchAndSort });
  };

  return (
    <Box>
      <Stack direction="column">
        {Object.values(FitStatus).map((value) => (
          <Checkbox
            data-testid={`availabilityFit_${value}`}
            key={`${value}`}
            isChecked={tempSearchAndSortType.availabilityFit.includes(value.toLowerCase())}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              if (e.target.checked) {
                tempSearchAndSortType.availabilityFit.push(value.toLowerCase());
              } else {
                const index = tempSearchAndSortType.availabilityFit.indexOf(value.toLowerCase());
                tempSearchAndSortType.availabilityFit.splice(index, 1);
              }
              onHandleBackgroundCheck(tempSearchAndSortType);
            }}
          >
            <Text
              px={3}
              style={{
                fontSize: '14px',
                fontWeight: 'normal',
              }}
            >
              {t(`common:profile.matchingRequisition.${value.toLowerCase()}Fit`)}
            </Text>
          </Checkbox>
        ))}

        <Checkbox
          data-testid="availabilityFit_notFit"
          isChecked={tempSearchAndSortType.availabilityFit.includes('NOT_FIT')}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (e.target.checked) {
              tempSearchAndSortType.availabilityFit.push('NOT_FIT');
            } else {
              const index = tempSearchAndSortType.availabilityFit.indexOf('NOT_FIT');
              tempSearchAndSortType.availabilityFit.splice(index, 1);
            }
            onHandleBackgroundCheck(tempSearchAndSortType);
          }}
        >
          <Text
            px={3}
            style={{
              fontSize: '14px',
              fontWeight: 'normal',
            }}
          >
            {t(`common:profile.matchingRequisition.noFit`)}
          </Text>
        </Checkbox>
      </Stack>
    </Box>
  );
};
